<script>
  import { onMount } from "svelte";
  import FABModal from "../../helper/modal";
  import Link from "./Link.svelte";
  export let fab_item = {};
  export let classNames = "";

  // Transform variables.
  classNames += ` fab-link-modal`;

  // Initiate jQuery functions.
  onMount(() => {
    jQuery(document).ready(function () {
      FABModal.event_close_link();
      FABModal.register_on_click_event();
    });
  });
</script>

<Link {fab_item} {classNames} />
